import DC from "../../common/DataConnector";
import LocalDataStore from "../../common/LocalDataStore";
import { reducerAppData } from "./AppDataReducer";

export async function appDataLoad(locationCode: string, dispatch: any) {
    let result = await DC.Get('/customer/wapp-data/' + locationCode);
    if (result.wasOk) {
        const productsPurchased: any[] = []
        const productsDic: any = {}
        for (let i = 0; i < result.data.products.length; i++)
            for (let x = 0; x < result.data.products[i].items.length; x++) {
                const productCode = result.data.products[i].items[x].productCode;
                if (result.data.productsRating[productCode])
                    result.data.products[i].items[x].rating = result.data.productsRating[productCode];
                if (result.data.productsPurchased[productCode])
                    productsPurchased.push(result.data.products[i].items[x])
                productsDic[productCode] = result.data.products[i].items[x]
                productsDic[productCode].categoryId = result.data.products[i].categoryId
                productsDic[productCode].indexCat = i;
                productsDic[productCode].indexProduct = x;

            }
        result.data.productsPurchased = productsPurchased;
        result.data.productsDic = productsDic;

        const productExtras:any = {}
        for(let x = 0; x < result.data.productExtras.length; x++){
            productExtras[result.data.productExtras[x].productExtraId] = result.data.productExtras[x]
        }
        result.data.productExtras = productExtras;
        dispatch(reducerAppData(result.data));
        LocalDataStore.locationIdSet(result.data.location.id)
        LocalDataStore.locationSet(result.data.location.code)
    }
}